import React ,{useState} from 'react';
import contactUs from '../../assets/images/contanctUspage/contactUs-Form .svg'
import { Controller, useForm } from "react-hook-form";
import { postData } from "../../api";
import PhoneInput from "react-phone-input-2";
import { Col, Container, Row, Form, Button, Toast } from "react-bootstrap";
import arrow from '../../assets/images/Arrow 1.png'
function ContactForm() {
    const [show, setShow] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    setError,
    clearErrors,
    reset,
  } = useForm();
  console.log("errors", errors);

  const handleContactSubmit = async (data) => {
    const url = `${process.env.REACT_APP_BASEURL}/contact/create`;

    const result = await postData(url, data);

    if (result.status) {
      setShow(true);
      reset();
    }
  };
  return (
    <div className='contact-us pb-5'>
      <Container className='pb-50 pt-50'>
          <Toast
              onClose={() => setShow(false)}
              show={show}
              delay={3000}
              autohide
              className="toast"
              bg="success"
            >
              <Toast.Body>We have received your email and will get back to you shortly. Thank you.</Toast.Body>
            </Toast>
        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="contact-form-section">
              <Row className="align-items-center">
                <Col lg={5} className="mb-5 mb-lg-0">
                  <div className="pe-lg-4">
                    <h5 className="text-secondary mb-2" style={{ fontWeight: 600 }}>CONTACT US</h5>
                    <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 800 }}>
                      Let's Start a <br /><span className="gradient-text">Conversation</span>
                    </h2>
                    <p className="text-muted">
                      Ready to start your next project with us? Give us a call or send us an 
                      email and we will get back to you as soon as possible!
                    </p>
                  </div>
                </Col>
                
                <Col lg={7}>
                  <Form onSubmit={handleSubmit(handleContactSubmit)} noValidate>
                    <Row>
                      <Col lg={6}>
                        <div className="input-group-modern">
                          <Form.Control
                            className="modern-input"
                            required
                            type="text"
                            placeholder="First Name"
                            {...register("firstName", { required: true })}
                          />
                          <i className="fa-regular fa-user input-icon-modern"></i>
                          {errors.firstName && (
                            <div className="text-danger mt-1 small ms-2">First Name is required</div>
                          )}
                        </div>
                      </Col>
                       <Col lg={6}>
                        <div className="input-group-modern">
                          <Form.Control
                            className="modern-input"
                            required
                            type="text"
                            placeholder="Last Name"
                            {...register("lastName", { required: true })}
                          />
                          <i className="fa-regular fa-user input-icon-modern"></i>
                          {errors.lastName && (
                            <div className="text-danger mt-1 small ms-2">Last Name is required</div>
                          )}
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="input-group-modern">
                          <Form.Control
                            className="modern-input"
                            required
                            type="email"
                            placeholder="Email Address"
                            {...register("email", {
                                required: "Email is required",
                                pattern: {
                                  value: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,6})+$/,
                                  message: "Invalid email format"
                                }
                            })}
                          />
                          <i className="fa-light fa-envelope-open input-icon-modern"></i>
                          {errors.email && (
                            <div className="text-danger mt-1 small ms-2">{errors.email.message}</div>
                          )}
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="input-group-modern">
                          <Form.Control
                            className="modern-input"
                            type='text'
                            placeholder="Subject"
                            {...register("message", { required: true })}
                          />
                          <i className="fa-light fa-tag input-icon-modern"></i>
                          {errors.message && (
                            <div className="text-danger mt-1 small ms-2">Subject is required</div>
                          )}
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="input-group-modern">
                          <Form.Control
                            className="modern-input"
                            as='textarea'
                            placeholder="Write your message..."
                            rows={4}
                            style={{ resize: 'none' }}
                            {...register("messageDetails", { required: true })} // Changed name to unique
                          />
                          <i className="fa-light fa-pen input-icon-modern" style={{ top: '25px' }}></i>
                        </div>
                      </Col>

                <Col lg={12}>
                        <Button className='modern-btn primary w-100' type="submit" disabled={show}>
                          Send Message
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )

}

export default ContactForm;
